import { fabric } from "fabric";
import customControls from "./customControlsHelper";

export default {
  addText,
  editTextColor,
  editTextFontFamily,
};

export function addText(canvas: fabric.Canvas) {
  let text = new fabric.Textbox("", {
    //@ts-ignore
    id: Math.round(new Date().getTime() / 1000),
    left: canvas.getWidth() / 2,
    top: canvas.getHeight() / 2,
    fill: "#404040",
    fontFamily: "Calibri",
    fontSize: 24,
    lockScalingFlip: true,
    lockScalingX: true,
    lockUniScaling: true,
    lockSkewingX: true,
    originX: "center",
    originY: "center",
    padding: 10,
  });
  // @ts-ignore
  text.customiseCornerIcons(customControls());
  canvas.add(text);
}

function editTextColor(canvas: fabric.Canvas, color: string) {
  canvas.forEachObject((object) => {
    if (
      object.type == "text" ||
      object.type == "i-text" ||
      object.type == "textbox"
    ) {
      object.set({
        fill: color,
      });
    }
  });
}

function editTextFontFamily(canvas: fabric.Canvas, fontFamily: string) {
  canvas.forEachObject((object) => {
    if (
      object.type == "text" ||
      object.type == "i-text" ||
      object.type == "textbox"
    ) {
      object.set({
        // @ts-ignore
        fontFamily: fontFamily,
      });
    }
  });
}
